export let hydrated = false;

export function updateHydrated() {
	hydrated = true;
}
